import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Grommet, TextInput, Image, Text } from "grommet";
import { debounce } from "lodash";
import React, { useCallback, useRef, useState } from "react";
import Avatar from "react-avatar";
import { useUser } from "../account/AccountStore";
import { GetOrganization, GetOrganizations } from "./IdentityAPI";
import { Organization } from "./OrganizationStore";

const formatSuggestions = (suggestions) =>
    suggestions.map(({ id, name, logoUri }, index, list) => ({
        label: (
            <Box direction="row" align="center" gap="small" border={index < list.length - 1 ? "bottom" : undefined} pad="small">
                <Avatar name={name} size="30px" round src={logoUri}></Avatar>
                <Text>
                    <strong>{name}</strong>
                </Text>
            </Box>
        ),
        value: { id, name, logoUri },
    }));

const OrganizationSearch = ({ onSelect, ...props }) => {
    const user = useUser();

    const [value, setValue] = useState("");
    const [organizations, setOrganizations] = useState([]);
    const [suggestions, setSuggestions] = useState([]);
    const textRef = useRef<HTMLInputElement>(null);

    const [selectedOrganization, setSelectedOrganization] = useState({} as Organization);

    React.useEffect(() => {
        GetOrganizations().then((result) => {
            setOrganizations(result);
            if (result.length == 1) {
                selectOrganization(result[0].id);
            } else {
                selectOrganization(user.organization.id);
            }
            setupSuggestions(result, "");
        });
    }, []);

    const setupSuggestions = (organizations, filter) => {
        setSuggestions(
            formatSuggestions(
                organizations.filter((o) => {
                    let r = new RegExp(filter, "i");
                    return r.test(o.name);
                })
            )
        );
    };

    const onChange = (event) => {
        const newValue = event.target.value;
        setValue(newValue);
        setupSuggestions(organizations, newValue);
    };

    const onSuggestionSelect = (event) => {
        const entity = event.suggestion.value;
        selectOrganization(entity.id);
        setValue("");
        //@ts-ignore
        textRef.current.blur();
    };

    const selectOrganization = (organizationId?) => {
        if (!organizationId) {
            onSelect({} as Organization);
            setSelectedOrganization({} as Organization);
        } else {
            GetOrganization(organizationId).then((organization) => {
                onSelect(organization);
                setSelectedOrganization(organization);
            });
        }
    };

    return (
        <Box direction="row-responsive" align="center">
            {!selectedOrganization.id && (
                <TextInput
                    ref={textRef}
                    placeholder={props.placeholder || "Search Organization ..."}
                    icon={<FontAwesomeIcon icon={["fad", "magnifying-glass"]} />}
                    suggestions={suggestions}
                    value={value}
                    onChange={onChange}
                    onSuggestionSelect={onSuggestionSelect}
                />
            )}
            {selectedOrganization.id && (
                <Box direction="row" align="center" gap="small" pad="small">
                    <Avatar name={selectedOrganization.name} size="30px" round src={selectedOrganization.logoUri}></Avatar>
                    <Text>
                        <strong>{selectedOrganization.name}</strong>
                    </Text>
                    <Box onClick={() => selectOrganization()}>
                        <FontAwesomeIcon icon={["fad", "xmark"]}></FontAwesomeIcon>
                    </Box>
                </Box>
            )}
        </Box>
    );
};

export default OrganizationSearch;
